import 'rc-tooltip/assets/bootstrap.css';

import Tooltip from 'rc-tooltip';
import { ReactNode } from 'react';
import Tree from 'react-animated-tree';

import { TreeNode } from './types/types';

const CreateTree = (node: TreeNode, key: number): ReactNode => {
  return (
    <>
      {node.subs && (!node.description || node.description === '') && (
        <Tree content={<span>{node.title}</span>} key={key}>
          {node.subs &&
            node.subs.map((e, i) => {
              return CreateTree(e, key * 10 + i);
            })}
        </Tree>
      )}
      {(!node.subs || node.subs.length === 0) &&
        (!node.description || node.description === '') && (
          <Tree content={<span>{node.title}</span>} key={key} />
        )}
      {node.subs && node.description && (
        <Tree
          content={<span>{node.title}</span>}
          key={key}
          type={
            <Tooltip
              placement='right'
              trigger={['hover']}
              overlay={<span>{node.description}</span>}
              destroyTooltipOnHide
            >
              <span className='tooltip-icon'>&#8505;</span>
            </Tooltip>
          }
        >
          {node.subs &&
            node.subs.map((e, i) => {
              return CreateTree(e, key * 10 + i);
            })}
        </Tree>
      )}
      {(!node.subs || node.subs.length === 0) && node.description && (
        <Tree
          content={<span>{node.title}</span>}
          key={key}
          type={
            <Tooltip
              placement='right'
              trigger={['hover']}
              overlay={<span>{node.description}</span>}
              destroyTooltipOnHide
            >
              <span className='tooltip-icon'>&#8505;</span>
            </Tooltip>
          }
        />
      )}
    </>
  );
};

const TreeStructure = ({ nodes }: { nodes: TreeNode[] }) => {
  return (
    <Tree content='Assessment' open>
      {nodes.map((e, i) => CreateTree(e, i))}
    </Tree>
  );
};

export default TreeStructure;
